import request from '@/api/request'

/**
 * 
 * 获取留言板列表
 */
export const getMessageList = (params) => {
    return request({
        url: '/radioweb/adm/messageBoard/getListPage',
        params,
        method: 'get'
    })
}
/**
 * 增加备注
 */
export const addMessageRemarks = (data) => {
    return request({
        url: '/radioweb/adm/messageBoard/updateMessageBoard',
        data,
        method: 'post'
    })
}